/*
 * @Description:
 * @Date: 2022-03-14 19:18:12
 */

import { reactive } from 'vue';
import { defineStore } from 'pinia';
import { storage } from '@/utils/storage';
import router from '@/router';
import { User } from '@cTypes/user';
import { entpRnv } from '@data-source/user/apis';
import appStore from '@/store';

const name = 'useUserStoreSetup';
const useSetup = defineStore(
  name,
  () => {
    const info = reactive<User>({
      authentication: null,
      loginUserId: null, // userId
      name: null,
      phone: null,
      entpName: null,
      entpId: null, //企业id
      isSuperAdministrator: 0, // 是否是超级管理员0否 1是
      entpType: null, // 主体类型: 1:工业 2:服务商 3:供应商
      duty: null, // 用户当前职能
      duties: null, //  具有哪些职能，这个是算出来的1：向日葵功能 2：工业功能 3：服务商功能 4：供应商功能 5：监管功能 6 运营基地
      entpAuthStatus: null
    });

    const setInfo = payload => {
      Object.assign(info, payload);
    };

    const login = async (payload: User) => {
      setInfo(payload);
      await initUserSystemData();
      window.location.reload();
    };
    const logout = () => {
      clearUser();
    };
    const clearUser = (query = {}) => {
      setInfo({ authentication: null });
      storage.clear();
      router.replace({
        path: '/login',
        query
      });
    };
    const setEntpAuthStatus = async () => {
      const { data } = await entpRnv();
      setInfo({ entpAuthStatus: data.authStatus });
    };
    // 登录后、APP加载调用一次
    const initUserSystemData = async () => {
      if (!info.authentication) return;
      await Promise.all([
        setEntpAuthStatus(),
        appStore.useMenuStoreSetup.setMenus() // 后端没有定下方案，就每次都拉下。当前用户角色、资源被修改后是否踢出当前用户重新登录？
      ]);
    };
    return {
      info,
      setInfo,
      login,
      logout,
      clearUser,
      setEntpAuthStatus,
      initUserSystemData
    };
  },
  {
    persist: true
  }
);

export { useSetup, name };
